export const UPDATE_PRODUCT_REVIEW_STATS = 'UPDATE_PRODUCT_REVIEW_STATS';

export function updateProductReviewStats(stats) {
    return {
        type: UPDATE_PRODUCT_REVIEW_STATS,
        payload: {
            averageOverallRating: stats.AverageOverallRating,
            totalReviewCount: stats.TotalReviewCount,
            averageFitRating: stats.averageFitRating
        }
    };
}
